import { Injectable } from "@angular/core";

import { ProfileName } from "@shared/Entities/Usuario/profile-name.enum";

import { AccessField } from "./Types/Enums/access-field.enum";

@Injectable()
export class UserCreationService {
  private readonly fields = {
    intermediary: {
      [AccessField.IntermediaryCode]: false,
      [AccessField.IntermediaryCodeUnit]: false,
      [AccessField.Company]: true,
      [AccessField.ProfileIdentification]: false,
    },
    [ProfileName.HealthProvider]: {
      [AccessField.Company]: true,
      [AccessField.HealthProviderCode]: true,
      [AccessField.OfficeCode]: false,
      [AccessField.ProfileIdentification]: true,
      [AccessField.UserCode]: false,
      [AccessField.IntermediaryCodeUnit]: false,
    },
    [ProfileName.Provider]: {
      [AccessField.Company]: true,
      [AccessField.HealthProviderCode]: true,
      [AccessField.OfficeCode]: false,
      [AccessField.ProfileIdentification]: true,
      [AccessField.UserCode]: false,
      [AccessField.IntermediaryCodeUnit]: false,
    },
    [ProfileName.Banca]: {
      [AccessField.Company]: true,
      [AccessField.UserCode]: true,
      [AccessField.ClientCode]: false,
      [AccessField.ClientCodeUnit]: false,
    },
    [ProfileName.ClientesCorporativos]: {
      [AccessField.Company]: true,
      [AccessField.ClientCode]: false,
      [AccessField.ClientCodeUnit]: false,
      [AccessField.ProfileIdentification]: true,
      [AccessField.UserCode]: true,
    },
    [ProfileName.LOJACK]: {
      [AccessField.Company]: true,
      [AccessField.UserCode]: true,
    },
    [ProfileName.Fiduciary]: {
      [AccessField.Company]: true,
      [AccessField.UserCode]: true,
      [AccessField.FiduciaryRnc]: true,
    },
    [ProfileName.Aerodom]: {
      [AccessField.Company]: true,
      [AccessField.UserCode]: true,
    },
    default: {
      [AccessField.Company]: true,
      [AccessField.UserCode]: true,
      [AccessField.IntermediaryCode]: false,
      [AccessField.IntermediaryCodeUnit]: false,
      [AccessField.ClientCode]: false,
      [AccessField.ClientCodeUnit]: false,
      [AccessField.ProfileIdentification]: false,
      [AccessField.HealthProviderCode]: false,
      [AccessField.OfficeCode]: false,
      [AccessField.PortalStyle]: false,
    },
  };

  public getRequiredFields(profile?: string): Partial<Record<AccessField, boolean>> {
    if (profile?.toLowerCase()?.includes("intermediario")) {
      return this.fields.intermediary;
    }

    return this.fields[profile] ? this.fields[profile] : this.fields.default;
  }
}
